export default __webpack_public_path__ + "static/media/fasting_13_11.36db45ee.jpg";